<clr-modal [(clrModalOpen)]="showAlert">
  <h3 class="modal-title">{{ data.title || 'Confirmation' }}</h3>
  <div class="modal-body">
    <p>{{ data.message }}</p>
    @if (data.details && isDetailsArray) {
      <ul class="list">
        @for (item of data.details; track item) {
          <li>{{ item }}</li>
        }
      </ul>
    }
    <ng-template #displayDetailsAsString>
      @if (data.details && !isDetailsArray) {
        <div>{{ data.details }}</div>
      }
    </ng-template>
    @if (data.isLoading) {
      <clr-spinner clrMedium>Chargement...</clr-spinner>
    }
  </div>
  @if (!data.isLoading) {
    <div class="modal-footer">
      @if (data.isConfirm) {
        <button type="button" class="btn btn-outline" (click)="onCancel()">
          {{ data.cancelLabel || 'Annuler' }}
        </button>
      }
      @if (data.isConfirm) {
        <button type="button" class="btn btn-primary" (click)="onConfirm()">
          {{ data.confirmLabel || 'Confirmer' }}
        </button>
      }
      @if (!data.isConfirm) {
        <button type="button" class="btn btn-primary" (click)="close()">
          OK
        </button>
      }
    </div>
  }
</clr-modal>
